module.exports = "/packs/cal-chevron-right-f82b4ed8c0da5ced1d7321d826e8ff6c.svg";